<div class="row d-flex p-1 align-items-center">
    <div class="col firstcol text-truncate">{{organisationCredit.validFrom | date:'dd-MM-yyyy' }}</div>
    <div class="col text-truncate" translate="Settings.OrganisationCreditsSection.{{organisationCredit.type}}"></div>
    <div class="col text-truncate">{{organisationCredit.amount}}</div>
    <div class="col text-truncate">{{organisationCredit.remaining}}</div>
    <div class="col text-truncate">{{organisationCredit.validUntil | date:'dd-MM-yyyy' }}</div>
    <div class="col text-truncate" translate="Settings.OrganisationCreditsSection.{{organisationCredit.status}}">
    </div>
    <div class="col text-end">
        <div *ngIf="organisationCredit.amount === organisationCredit.remaining && !NotAllowedToAddOrDeleteCredits" class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li *ngIf="!NotAllowedToAddOrDeleteCredits"><a class="dropdown-item pt-1 pb-1" translate="Button.Delete" (click)="delete()"></a></li>
            </ul>
        </div>
    </div>
</div>